module.exports = __webpack_public_path__ + "img/kushki_CCslogo.d5f586ac.png";